import without from "src/lib/without";
import { SET_STATE, RESET_STATE } from "src/redux/app/actions";
import { FIN30X1_SKU, MIN65_SKU } from "src/data/product-skus";
import { actionTypes as userActionTypes } from "src/redux/user/actions";
import { actions as signupActions } from "src/redux/signup/actions";
import { parseUserActiveCoupons } from "../helpers";
import { actionTypes } from "./actions";

export const defaultState = {
  version: 4,
  isPending: false,
  error: null,
  answers: {
    condition: {},
    medicalHistory: {},
    terms: {},
  },
  productOptions: {
    product: [FIN30X1_SKU, MIN65_SKU],
  },
  coupons: {
    data: [],
    error: null,
  },
};

export default function hairLossConsultation(
  state = defaultState,
  action = {}
) {
  switch (action.type) {
    case SET_STATE:
      return state.version === defaultState.version ? state : defaultState;

    case RESET_STATE:
      return defaultState;

    case actionTypes.HAIRLOSS_CONSULTATION_SUBMIT_PENDING:
      return {
        ...state,
        isPending: true,
      };

    case actionTypes.HAIRLOSS_CONSULTATION_SUBMIT_ERROR:
      return {
        ...state,
        isPending: false,
        error: action.payload,
      };

    case actionTypes.HAIRLOSS_CONSULTATION_SUBMIT_SUCCESS:
      return defaultState;

    case actionTypes.HAIRLOSS_CONSULTATION_SET_PRODUCT_OPTIONS:
      return {
        ...state,
        productOptions: {
          ...state.productOptions,
          ...action.payload,
        },
      };

    case actionTypes.HAIRLOSS_CONSULTATION_COUPONS_FETCH_SUCCESS:
      return {
        ...state,
        coupons: {
          ...state.coupons,
          data: [action.payload],
        },
      };

    case userActionTypes.USER_FETCH_ACTIVE_COUPONS_SUCCESS: {
      const userActiveCoupons = [].concat(
        parseUserActiveCoupons(action.payload)
      );
      return {
        ...state,
        coupons: {
          ...state.coupons,
          data: [...userActiveCoupons],
        },
      };
    }

    case actionTypes.HAIRLOSS_CONSULTATION_COUPONS_FETCH_ERROR:
    case userActionTypes.USER_FETCH_ACTIVE_COUPONS_ERROR:
      return {
        ...state,
        coupons: {
          ...state.coupons,
          data: [],
          error: action.payload,
        },
      };

    case actionTypes.HAIRLOSS_CONSULTATION_SAVE:
      return {
        ...state,
        answers: {
          ...state.answers,
          ...action.payload.answers,
        },
      };

    case signupActions.SIGNUP__REMOVE_PRODUCT_IN_BASKET:
      return {
        ...state,
        productOptions: {
          ...state.productOptions,
          product: without(state.productOptions.product, action.payload),
        },
      };

    default:
      return state;
  }
}
